import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import Chip from '@/components/ui/Chip';
import theme from '@/helpers/theme';

import { useDispenseAssets } from '@/hooks/useDispenseAssets';
import type { CassetteView } from '@/types/generated/athena';

type Props = {
  cassettes: CassetteView[];
};

const border = `1px solid ${theme.palette.neutral?.[300]}`;

const BillsTable = ({ cassettes }: Props) => {
  const { billsMap } = useDispenseAssets();

  return (
    <TableContainer
      sx={{
        border,
        borderRadius: '6px',
        '.MuiTableRow-root:not(:last-child)': {
          borderBottom: border,
        },
        '.MuiTableCell-root:not(:last-child)': {
          borderRight: border,
        },
        '.MuiTableCell-body': {
          background: 'white',
        },
        '.MuiTableCell-root': {
          textAlign: 'center',
        },
      }}
    >
      <Table sx={{ tableLayout: 'fixed' }}>
        <TableHead>
          <TableRow>
            {cassettes.map(({ cassette_index }) => (
              <TableCell key={`${cassette_index}`} sx={{ p: '2px 16px' }}>
                Cassette {cassette_index}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            {cassettes.map(({ bill_note_id, cassette_index }) => (
              <TableCell key={cassette_index} sx={{ p: 0 }}>
                <Typography variant="overline" color="text.secondary">
                  {!bill_note_id
                    ? '-'
                    : `${billsMap[bill_note_id]?.at(0) ?? '-'} (${billsMap[bill_note_id]?.at(1) ?? '-'})`}
                </Typography>
              </TableCell>
            ))}
          </TableRow>
          <TableRow>
            {cassettes.map(({ count, cassette_index, bill_note_id }) => (
              <TableCell key={cassette_index} sx={{ p: '6px 16px' }}>
                {!bill_note_id ? (
                  <Chip label="Empty" color="primary" size="small" sx={{ fontWeight: 'bold' }} />
                ) : (
                  <Typography variant="body1" fontWeight="bold">
                    {count}
                  </Typography>
                )}
              </TableCell>
            ))}
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default BillsTable;
